module.exports = __webpack_public_path__ + "static/media/product_10.137c8e82.jpg";